
export default () => ({
  isLoading: false,
  serviceLoaded: false,
  fromRender: {
    date: null,
    country: null
  },
  cities: [],
  visas: {
    isLoading: [],
    hasError: false,
    searchId: null,
    current: {
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB'
      }
    },
    ids: [],
    selected: [],
    collection: [],
    errors: []
  },
  toursVisas: {
    id: null,
    searchId: null,
    visas: []
  },
  form: {
    countryId: null,
    cityId: [],
    currency: 'RUB'
  },
  penalties: {
    isLoading: true,
    hasError: false,
    collection: [],
    errors: []
  },
})
